import { render, staticRenderFns } from "./CardQuestions.vue?vue&type=template&id=09f7412f&"
import script from "./CardQuestions.vue?vue&type=script&lang=js&"
export * from "./CardQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports